export enum PaymentOption {
  CREDIT_CARD = 'CreditCard',
  SAVED_CREDIT_CARD = 'SavedCreditCard',
  INVOICE = 'Invoice',
}
